import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function Assessment({
  singleSubjectId,
}: {
  singleSubjectId?: string;
}) {
  const { id } = useScopeParams();

  return (
    <PageTemplate
      title="Measures: Assessments"
      tooltipText="Explore assessments data, create data subsets, view visualizations, and download data and visualizations."
      type="assessments"
      constants={{
        wikiLink: "/wiki/guides/exploration-measures-assessments",
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/assessments`,
      }}
      subjectId={singleSubjectId}
    />
  );
}
